module.exports = __webpack_public_path__ + "img/13_climate_action.15221071.svg";